import { Injectable } from '@angular/core';
import { UnsupportedBrowserPopup } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { HeaderFooterMachCore } from '../../models/header-footer-mach-core/header-footer-mach-core.interfaces';

@Injectable({
  providedIn: 'root'
})
export class UnsupportedBrowserAdapterService {
  transformContent(content: HeaderFooterMachCore): UnsupportedBrowserPopup {
    return content.unsupportedBrowserPopup;
  }
}
